export function toZero(value, zero) {
	return zero - value;
}

export function findIntersect(prev, current) {
	return -100 * (prev / (current - prev));
}
